import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { CacheService } from 'app/services/cache.service';
import { UserService } from 'app/services/user.service';

@Component({
	selector: 'app-alert-info-status',
	templateUrl: './alert-info-status.component.html',
	styleUrls: ['./alert-info-status.component.scss'],
})
export class AlertInfoComponent implements OnInit {
	validationBankRespose: { status: string; text: string };
	paymentScreen = false;

	wePayoutStatus = {
		validated: 'SESSION.BANK_DATA.VALIDATED',
		pending: 'SESSION.BANK_DATA.INFO',
		has_errors: 'SESSION.BANK_DATA.ERROR',
		on_going: 'SESSION.BANK_DATA.PROCESSING',
	};

	constructor(
		protected router: Router,
		protected cacheService: CacheService,
		public userService: UserService
	) {}

	ngOnInit(): void {
		this.userService.getProfileData().then((user) => {
			const paymentStatus = user.paymentAccount?.validationStatus;

			if (paymentStatus) {
				const paymentStatusMessage = user.paymentAccount.status;
				let text =
					this.wePayoutStatus[paymentStatus] || 'SESSION.BANK_DATA.INFO';

				if (paymentStatus === 'has_errors') {
					text = paymentStatusMessage;
				}

				this.validationBankRespose = { status: paymentStatus, text };
			}
		});

		this.paymentScreen = this.isPaymentScreen(this.router.url);
	}

	isPaymentScreen(url: string): boolean {
		return url.includes('account/payment') ? true : false;
	}
}
